
import { Component, Prop, Vue } from "vue-property-decorator";

// let NodeContent = {
//   props: {
//     node: {
//       required: true,
//     },
//   },
//   render(h) {
//     const parent = this.$parent;
//     const tree = parent.tree;
//     const node = this.node;
//     const { data, store } = node;
//     return tree.$scopedSlots.default
//       ? tree.$scopedSlots.default({ node, data })
//       : ` <span class="el-tree-node__label">{node.label}</span>`;
//   },
// };

@Component({ components: {} })
export default class GsTreeNode extends Vue {
	@Prop() node: string;
	@Prop() index: number;
	@Prop() level: number;
	@Prop() parent: any;

	isExpend = true;

	nodeClick() {
		this.isExpend = !this.isExpend;
	}
}
